import {useEffect, useState} from 'react';
import {useSession} from "../../../../firebase/UserProvider";

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function authHeaders() {
    const t = localStorage.getItem('access_token');
    return t ? {'Authorization': `Bearer ${t}`} : {};
}

const useFeeds = (refreshKey = 0) => {
    const {user} = useSession();
    const [feeds, setFeeds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid) { setFeeds([]); setLoading(false); return; }
        setLoading(true);
        fetch(`${BASE}/api/feeds?owner=${encodeURIComponent(user.uid)}`, {headers: authHeaders()})
            .then((r) => r.ok ? r.json() : [])
            .then((data) => { setFeeds(Array.isArray(data) ? data : []); setLoading(false); })
            .catch((err) => { setError(err); setLoading(false); });
    }, [user?.uid, refreshKey]);

    return {feeds, loading, error};
};

export default useFeeds;
